import { themeGet } from '@styled-system/theme-get';
import React, {  } from 'react';
import styled from 'styled-components';
import { IncrementNumberInput } from '../../../components/IncrementNumberInput/IncrementNumberInput';
import { IRecommendationOptions } from '../../../logic/store/Plans/IRecommendationOptions';
import { ICropConfig, soyId } from '../../../logic/store/Seeds/CropsSlice';
import { ICropBrandAssociation } from '../CropBrandAssociation';

export const EditRecommendationOptions = ({
	options,
	cropBrand,
	cropConfig,
	buttonArea,
	onUpdateTargetYield,
	onUpdateAcres,
	onUpdateSeedsRequired,
}: {
	options: IRecommendationOptions;
	cropBrand: ICropBrandAssociation;
	cropConfig: ICropConfig;
	buttonArea: React.ReactNode;
	onUpdateTargetYield: (value: number) => void;
	onUpdateAcres: (value: number) => void;
	onUpdateSeedsRequired: (value: number) => void;
}) => 
{
	return (
		<Container className='MainEditorRecommendationInputs'>
			<div className='FieldlessRecommendation_MainContainer'>
				<div className='FieldlessRecommendation_InnerContainer'>
					{!(soyId === cropBrand.cropId) && <div className='TargetYield_IncrementInput'>
						<IncrementNumberInput
							interval={5}
							max={cropConfig.maxYield ?? 0}
							min={cropConfig.minYield ?? 0}
							onChange={onUpdateTargetYield}
							value={options.targetYield}
							title={'Target Yield'}
						/>
					</div>}
					<div className='Acres_IncrementInput'>
						<IncrementNumberInput
							interval={5}
							max={99999}
							min={0}
							onChange={onUpdateAcres}
							value={options.acres}
							title={'Acres'}
						/>
					</div>
					<div className='SeedsRequired_IncrementInput'>
						<IncrementNumberInput
							interval={1}
							max={10}
							min={1}
							onChange={onUpdateSeedsRequired}
							value={options.seedsRequired}
							title={'Seeds Required'}
						/>
					</div>
					<div className='RunRecommendation_Button' >
						{buttonArea}
					</div>
				</div>
			</div>
		</Container>
	);
};


const Container = styled.div`
	background: ${themeGet('colors.white')};
	border: 1px solid ${themeGet('colors.lightestGrey')};
	border-radius: 5px;
	padding: 14px;
	margin-top: 20px;
	margin-bottom: 8px;
	font-family: ${themeGet('fonts.base')};
	font-size: ${themeGet('fontSizes.normal')};
	font-weight: ${themeGet('fontWeights.bold')};

	.FieldlessRecommendation_MainContainer {
		display: flex;
		flex-wrap: wrap;

		.FieldlessRecommendation_InnerContainer {
			display: flex;
			flex-wrap: wrap;

			.TargetYield_IncrementInput,
			.Acres_IncrementInput,
			.SeedsRequired_IncrementInput {
				display: flex;
				align-items: center;
				margin-right: 20px;
			}
			.RunRecommendation_Button {
				display: flex;
				align-items: center;
				margin-top: 25px;
				margin-left: auto;
			}
		}
	}
`;
